import { render, staticRenderFns } from "./TrafficProfile.vue?vue&type=template&id=5d314f34&"
import script from "./TrafficProfile.vue?vue&type=script&lang=js&"
export * from "./TrafficProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports